import React, { useEffect, useState } from 'react'
import NavigationBar from '../components/NavigationBar'
import LandingFooter from '../components/LandingFooter'
import { MDBAlert, MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import { ContactusImg } from '../assets/images/images'
import { customPremium } from '../../services/apiServices'
import { isValidPhoneNumber } from 'react-phone-number-input'


const RequestDemo = () => {
    const [Alerttxt, setAlerttxt] = useState("");
    const [contact, SetContactForm] = useState({
        fname: "",
        email: "",
        number: "",
        inquiry: ""
    });

    function updateContactForm(value) {
        return SetContactForm((prev) => {
            return { ...prev, ...value };
        });
    }

    const [ErrorContactInfo, setErrorContactInfo] = useState({});


    const isEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }


    let validateForm = (e) => {
        let errors = {};
        if (isEmpty(contact.fname)) {
            errors.fname = "Name can't be blank";
        }
        if (isEmpty(contact.email)) {
            errors.email = "Field can't be blank";
        }
        else if (!isEmail(contact.email)) {
            errors.email = "Please enter valid email";
        }
        if (isEmpty(contact.number)) {
            errors.number = "Number can't be blank";
        }
        // else if (!isValidPhoneNumber(contact.number)) {
        //     errors.number = "Please enter valid Number";
        // }
        if (isEmpty(contact.inquiry)) {
            errors.inquiry = "Text can't be blank";
        }
        if (isEmpty(errors)) {
            return true;
        } else {
            return errors;
        }
    };


    const isEmpty = (thing) => {
        let empty = false;
        switch (typeof thing) {
            case 'undefined':
                empty = true;
                break;
            case 'string':
                if (thing.trim().length === 0) {
                    empty = true;
                }
                break;
            case 'object':
                if (thing === null) {
                    empty = true;
                } else if (Object.keys(thing).length === 0) {
                    empty = true;
                }
                break;
            default:
                empty = false;
        }

        return empty;
    }

    const sendingMail = async (e) => {
        e.preventDefault();
        console.log("Triggered sendingMail");
        console.log("ContactInfo", contact);

        let errors = validateForm(e);

        if (errors === true) {
            setErrorContactInfo({});

            try {
                const saverep = await customPremium(contact);

                console.log(saverep);

                if ((saverep.status === 200)) {
                    setAlerttxt("Email sent successfully!");

                    SetContactForm({
                        fname: "",
                        email: "",
                        number: "",
                        inquiry: ""
                    });
                }
                else {
                    setAlerttxt("Failed to send email. Please try again.")
                }

            } catch (err) {
                console.error("Error while sending email:", err);
                alert("Something went wrong. Please try again later.");
            }

        } else {
            setErrorContactInfo(errors);
        }
    };
    return (
        <>
            <NavigationBar classText="blue-logo" from={'contact'} />

            <div className="lp">
                <div className="home-section">
                    <MDBContainer>
                        <MDBRow className='sm-demo'>
                            <MDBCol sm='12' md='5' className='lp_demo-leftcol lp_bgimg '>
                                <img src={ContactusImg} alt="" />
                                <div className='lp_textcontent' >
                                    {/* <h2>Experience EasyMember in Action</h2> */}
                                    <p>Discover how EasyMember simplifies <br /> membership management...</p>
                                </div>
                            </MDBCol>
                            <MDBCol sm='12' md='7' className='demo-rightcol'>
                                <div className="card">
                                    <div className="card-body">
                                        <h3 className="text-center">Contact us </h3>
                                        <p className="card-text text-center">Share your details and let`s prioritize your convenience! We’ll reach out at your preferred time.</p>
                                        <div>
                                            <MDBRow>
                                                <MDBCol sm='12' md='6'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span className="input-group-text dived" id="addon-wrapping"><i class="fas fa-user"></i></span>
                                                        <input type="text"
                                                            value={contact.fname}
                                                            onChange={(e) => updateContactForm({ fname: e.target.value })}
                                                            required
                                                            className="form-control" placeholder="Enter Name" aria-label="Enter Name" />
                                                    </div>
                                                    {ErrorContactInfo?.fname && (<p className="text-danger">{ErrorContactInfo.fname}</p>)}
                                                </MDBCol>
                                                {/* <MDBCol sm='12' md='6'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span class="input-group-text" id="addon-wrapping"><i class="fas fa-user"></i></span>
                                                        <input type="text"
                                                            value={contact.lname}
                                                            onChange={(e) => updateContactForm({ lname: e.target.value })}
                                                            required
                                                            class="form-control" placeholder="Last Name" aria-label="lastname" />
                                                    </div>
                                                </MDBCol> */}
                                                <MDBCol sm='12' md='6'>
                                                    <div className="input-group input-group-lg mb-3">
                                                        <span className="input-group-text dived" id="addon-wrapping"><i class="fas fa-phone-alt icon-position"></i></span>
                                                        <input type="text"
                                                            value={contact.number}
                                                            onChange={(e) => updateContactForm({ number: e.target.value })}
                                                            required
                                                            className="form-control" placeholder="Number" aria-label="Number" />
                                                    </div>
                                                    {ErrorContactInfo.number && (<p className="text-danger">{ErrorContactInfo.number}</p>)}
                                                </MDBCol>
                                                <MDBCol sm='12' md='12'>
                                                    <div class="input-group input-group-lg mb-3">
                                                        <span className="input-group-text dived" id="addon-wrapping"><i class="fas fa-envelope"></i></span>
                                                        <input type="text"
                                                            value={contact.email}
                                                            onChange={(e) => updateContactForm({ email: e.target.value })}
                                                            required
                                                            className="form-control" placeholder="E-mail" aria-label="E-mail" />
                                                    </div>
                                                    {ErrorContactInfo.email && (<p className="text-danger">{ErrorContactInfo.email}</p>)}
                                                </MDBCol>
                                                <div class=" mb-3">
                                                    <textarea className="form-control"
                                                        value={contact.inquiry}
                                                        onChange={(e) => updateContactForm({ inquiry: e.target.value })}
                                                        required
                                                        id="validationTextarea" rows={3} placeholder="Inquiry... " ></textarea>
                                                    {ErrorContactInfo.inquiry && (<p className="text-danger">{ErrorContactInfo.inquiry}</p>)}
                                                </div>
                                                <div >
                                                    {/* <div class="form-check align-items-start">
                                                        <input class="form-check-input mt-1" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label class="form-check-label" for="flexCheckDefault">By submitting this form, I confirm that I have read and understood <span class="lp_revenue_header"> <a href='#' className='p-0'> privacy policy</a> </span> .</label>
                                                    </div> */}
                                                    <div className='d-flex align-items-end justify-content-end'>
                                                        <button className='my-3 lp_btn lp_btnsm lp_fillbtn ' color='primary' onClick={(e) => sendingMail(e)}>
                                                            Submit
                                                        </button>
                                                    </div>

                                                </div>
                                            </MDBRow>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>
                </div>

                <div className='my-5'>
                    <MDBContainer>
                        <MDBRow>
                            <MDBCol sm='12' md='4' className='mb-2'>
                                <div className='card text-center shadow-0 border lp_demofooter h-100'>
                                    <div className='card-body'>
                                        <i className='bi bi-whatsapp'> </i>
                                        <div className='mb-5'>
                                            <h4>WhatsApp Us</h4>
                                            <p className='mb-0'>Chat to EasyMembr expert</p>
                                            <p className='connect-link'><a href='https://wa.me/918019296262' target='_blank' rel='noopener noreferrer'>
                                                +91 8019296262
                                            </a></p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                            <MDBCol sm='12' md='4' className='mb-2'>
                                <div className='card text-center shadow-0 border lp_demofooter h-100'>
                                    <div className='card-body'>
                                        <i className='bi bi-telephone'> </i>
                                        <div className='mb-5'>
                                            <h4>Call us</h4>
                                            <p className='mb-0'>Speak to EasyMembr expert</p>
                                            <p className='connect-link'>+91 8019296262</p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                            <MDBCol sm='12' md='4' className='mb-2'>
                                <div className='card text-center shadow-0 border lp_demofooter h-100'>
                                    <div className='card-body'>
                                        <i className='bi bi-envelope'> </i>
                                        <div className='mb-5'>
                                            <h4>Email us</h4>
                                            <p className='mb-0'>Connect with EasyMembr dedicated support team</p>
                                            <p className='connect-link'> <a href='mailto:contact@easymembr.com'>contact@easymembr.com</a></p>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>
                </div>
            </div>

            <MDBAlert
                color={Alerttxt.includes("Failed") ? "danger" : "success"}
                autohide
                position='top-right'
                delay={4000}
                appendToBody
                open={Alerttxt != ""}
                onClose={() => setAlerttxt("")}
            >
                {Alerttxt}
            </MDBAlert>

            <LandingFooter />
        </>
    )
}

export default RequestDemo
